/*===================================================================
=       USER API                           =
====================================================================*/
/**
 * Manage the user data, sessions and authentication.
 */

import axios from "axios"
import { User, UserFilter } from "../types/user.types"
import { ResponseAPIWithPagination } from "../../../types/responsesAPI.types"
import { getUserFilter } from "./userAPI.utils"

const BASE_URL = process.env.REACT_APP_URL_BACKEND
/**
 * get Single user 
 * 
 * @param userId user id
 */
export const getSingleUserProtectedAPI = (userId: string) => {
    return axios.get<User>(`${BASE_URL}/user/${userId}`)
}

export const getSingleUserProtectedAPIV2 = async (userId: string) => {
  
    return (await axios.get<User>(
        `${BASE_URL}/api/v2/users/${userId}`)).data;
}
export const searchUserProtectedAPI = async (query: string, page: number = 0, pageSize = 0, filter?: UserFilter ) => {
    const queryWhere = getUserFilter({filter, })
    return (await axios.get<ResponseAPIWithPagination<User>>(
        `${BASE_URL}/api/v2/users/search?query=${query}&pageSize=${pageSize}&currentPage=${page}&whereQuery=${queryWhere}`)).data;
}

export const resetPasswordAPI = async (requestId: string, newPassword: string) => {
    return (await axios.post<ResponseAPIWithPagination<User>>(
        `${BASE_URL}/api/v2/compta/users/reset-password`, {
            request_id: requestId,
            password: newPassword
        })).data;
}

export const GET_BASE_URL_CURRENT_USER_TEAM_MEMBERS = `${BASE_URL}/api/v2/compta/users/teams/member`
export const GET_BASE_URL_CURRENT_USER_TEAM_MANAGERS = `${BASE_URL}/api/v2/compta/users/teams/manager`

export const BASE_USER_RESET_PASSWORD_REQUEST = `${BASE_URL}/api/v2/compta/reset-password-requests`

export const BASE_USER_API = `${BASE_URL}/api/v2/compta/users`

const userAPI = {
    getSingleUserProtectedAPI,
    searchUserProtectedAPI,
    getSingleUserProtectedAPIV2,
    resetPasswordAPI
}

export default userAPI
